const PCIE_BANDWIDTH_EXCEED = [
    'gpuName',
    'pex',
    'actual',
    'expected'
]

export {
    PCIE_BANDWIDTH_EXCEED
}